import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const CheckboxCheckmark = ({ height = '18px', fill = 'white', width = '18px', }) => {
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: `-3 -5 18 18`, fill: 'none', children: _jsx("path", { d: 'M10.7495 1.25048L4.64233 7.35767L1.17383 3.88908', stroke: fill, strokeWidth: '1' }) }));
};
//# sourceMappingURL=CheckboxCheckmark.js.map